import ConfiguratorSelect from './configurator-select';

class ConfiguratorApparat {
    constructor(select) {
        this.softwareSelect = new ConfiguratorSelect('#software-select');
        this.softwareDesc = jQuery('.js-software-desc');
    }


    _events() {
        this.softwareSelect.onChange((select, target) => {
            this.softwareDesc.hide();
            this.softwareDesc.filter(`[data-software-key=${select.val()}]`).show();
        });
    }

    init() {
        if (this.softwareSelect || this.softwareDesc.length) {
            try {
                this._events();
            } catch (e) {

            }
        }
    }
}

export default ConfiguratorApparat;
